import React, { Component } from "react";
import { connect } from "react-redux";
import Updatesqr from "../Components/updatQrCode";


import { close_snack_bar } from "../../../common/snackbar/action";

import {
    createQr,
    viewAllQr,
    viewQrById,
    addQrCode
} from "../../action";
export class Controller extends Component {
    render() {
        return (
            <Updatesqr {...this.props} />
        );
    }
};
export const mapStateToProps = store => {
    return {
        login: store.login,
        loader: store.loader,
        snackbar: store.snackbar,
        QrCode: store.QrCode,
    };
};
export const mapDispatchToProps = dispatch => {
    return {
        
        close_snack_bar: () => {
            dispatch(close_snack_bar());
        },


        viewAllQr: (searchInput,) => {
            dispatch(viewAllQr(searchInput,));
        },
        viewQrById: (token, id) => {
            dispatch(viewQrById(token, id));
        },

        // createQr: (qr_id, name, email, video_link) => {
        //     dispatch(createQr(qr_id, name, email, video_link));
        // },
        addQrCode: (token, user_id, qr_id, name, email, link, qrCodeValue) => {
            dispatch(addQrCode(token, user_id, qr_id, name, email, link, qrCodeValue));
        },


    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
